export default {
      id: "key-usage",
      viewBox: "0 0 23 22",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#key",
      toString: function () {
        return this.url;
      }
    }